import { isObject } from "lodash-es";
import type { StoreData } from "@features/stores/types";

export const storeTypeGuard = (data: StoreData | string): data is StoreData =>
    isObject(data) && data.hasOwnProperty("storeId");
